module.exports = __webpack_public_path__ + "static/kiss-3fddbc687227143a719785e77401830c.jpg";